import { useRouteMatch } from 'react-router-dom'
import { DOC_PATH } from 'paths'
import { ArticlePathRedirect } from './ArticlePathRedirect'

const ArticleIdWrapper = () => {
  const articleRouteMatch = useRouteMatch<any>(DOC_PATH + '/:rest*')
  const articleIdInUrl = articleRouteMatch?.params.slug.split('-').pop()

  if (articleRouteMatch?.params.slug && articleIdInUrl) {
    return <ArticlePathRedirect articleSlug={articleRouteMatch.params.slug} articleId={articleIdInUrl} />
  }

  return null
}

export default ArticleIdWrapper
